<template>
  <modal v-if="showDialog">
    <template v-slot:header>
      <h5 class="modal-title">{{$t('form.upload-from-template.title')}}</h5>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close()">
        <span aria-hidden="true"><img src="@/assets/img/static/b-icon_close_x.svg" alt=""></span>
      </button>
    </template>

    <template v-slot:body>
      <div class="modal-body__content-download">
        <template v-for="field in fields">
          <div class="modal-body__group">
            <div class="a-label" v-t="field.name.label"></div>
            <dropdown-new class="a-input-group select-w-95" :options="availableColumns" v-model="field.column"></dropdown-new>
          </div>
        </template>
      </div>
    </template>

    <template v-slot:footer>
      <button class="gui-btn gui-btn--white-border gui-btn--ep" type="button" @click="close()" v-t="'buttons.cancel'"></button>
      <button class="gui-btn gui-btn--red gui-btn--ep" type="button" @click="$emit('ready', { fields, template })" v-t="'buttons.upload'"></button>
    </template>
  </modal>
</template>

<script>
  export default {
    data: () => ({
      showDialog: false,
      template: undefined,
      fields: undefined,
      columns: undefined
    }),

    computed: {
      availableColumns() {
        const columns = this.columns.map(e => ({
          ...e,
          disabled: !!_.find(this.fields, { column: e.id })
        }));

        return [
          { name: 'form.upload-from-template.column-not-chosen' }
        ].concat(columns);
      }
    },

    methods: {
      open(template) {
        this.template = template;
        this.fields = template.fields;
        this.columns = template.columns.map(e => ({name: e, id: e}));
        this.showDialog = true;
      },

      close() {
        this.showDialog = false;
        this.template = undefined;
      }
    }
  }
</script>

<style scoped>

</style>
